/*
 * © 2025 Fannie Mae. All rights reserved.
 * This software contains confidential information and trade secrets of Fannie Mae.
 * Use, disclosure, or reproduction is prohibited without the prior written consent of Fannie Mae.
 */

import moment from "moment";

// Renders the requestDate cell as MM/DD/YYYY HH:mm
export default (params) => {
  if (!params.value) return '—';
  const requestDate = moment(params.value);
  return (
    <span className="request-date">{requestDate.format("MM/DD/YYYY HH:mm")}</span>
  );
}